import { alphabet } from './string';
import { SheetProcessingRecord } from '../types/generic';

export const ANPR_HEADERS: string[][] = [
	[
		'Date/Time',
		'Insert Date/Time',
		'Country',
		'VRM',
		'GPS',
		'SET/Mobile',
		'SET/Mobile Notes',
		'Camera',
		'Status',
		'VOI List',
		'Class',
		'Domain',
		'Make',
		'Model',
		'Colour',
		'Tax Class',
		'Notes',
	],
	[
		'VRM',
		'Day',
		'Date',
		'Time',
		'System',
		'Camera Name',
		'Camera Description',
		'Direction Of Travel',
		'Latitude',
		'Longitude',
		'Eastings',
		'Northings',
		'Make',
		'Model',
		'Specification',
		'Colour',
		'Tax Class',
	],
	['Date/Time', 'Insert Date/Time', 'VRM', 'GPS', 'SET/Mobile', 'SET/Mobile Notes', 'Camera', 'Domain', 'Make', 'Model', 'Colour'],
];

export const specialSheetOptions = ['Call Logs', 'Locations', 'Contacts'];
export const genericSheetOptions = [
	'Summary',
	'Device Information',
	'Applications',
	'Archives',
	'Audio',
	'Autofill',
	'Calendar',
	'Chats',
	'Configurations',
	'Cookies',
	'Databases',
	'Device Events',
	'Device Users',
	'Document',
	'Downloads',
	'Emails',
	'Images',
	'Installed Applications',
	'Instant Messages',
	'Network Usages',
	'Notes',
	'Passwords',
	'Searched Items',
	'Shortcut',
	'Text',
	'Timeline',
	'User Accounts',
	'User Dictionary',
	'Videos',
	'Web Bookmarks',
	'Web History',
	'Wireless Networks',
];

export const subheaders = [...alphabet].filter((letter) => {
	return genericSheetOptions.some((opt) => opt.startsWith(letter));
});

export const getInitialSheets = (): SheetProcessingRecord => {
	const init: SheetProcessingRecord = {};
	specialSheetOptions.forEach((opt) => {
		init[opt] = false;
	});
	genericSheetOptions.forEach((opt) => {
		init[opt] = false;
	});

	return init;
};
